import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.jsx';
import { initAnalytics, trackEvent } from './services/analytics.js';
import './src/styles.css';

initAnalytics();
trackEvent('app_loaded', { timestamp: new Date().toISOString() });

const enableSEO = process.env.VITE_ENABLE_SEO === 'true';
const app = enableSEO ? <HelmetProvider><App /></HelmetProvider> : <App />;

ReactDOM.createRoot(document.getElementById('root')).render(<React.StrictMode>{app}</React.StrictMode>);

